















































import {Vue, Component, Watch} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service"
import {mixins} from "vue-class-component"
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {PodesavanjeSistema} from "@/services/BackendProxies";

@Component({})
export default class PodesavanjaSistema extends mixins(ComponentBaseMixin) {

    podesavanje = PodesavanjeSistema.fromJS({});

    async created() {
      this.podesavanje = await this.loadData(() => dataProxy.vratiPodesavanjeSistema())();
    }

    async sacuvajPodesavanje() {
     this.podesavanje = await this.saveData(() => dataProxy.sacuvajPodesavanjeSistema(this.podesavanje))();
    }

    fokusiraj(refValue) {
        (<any>this.$refs[refValue]).focus();
    }

}
